"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchMultiReceipts = fetchMultiReceipts;
const core_1 = require("@apollo/client/core");
const getMultiReceipts_js_1 = require("./queries/getMultiReceipts.js");
const maps_js_1 = require("../common/maps.js");
const client = new core_1.ApolloClient({
    link: new core_1.HttpLink({
        uri: "https://graphql.mainnet.sui.io/graphql",
    }),
    cache: new core_1.InMemoryCache({
        typePolicies: {
            Address: {
                keyFields: (addressObj) => {
                    const objectKeys = Object.keys(addressObj)
                        .filter((k) => k !== "__typename")
                        .sort();
                    const uniqueKey = objectKeys.join(",");
                    // Return the final unique ID string
                    return `Address:${uniqueKey}`;
                },
            },
        },
    }),
});
const getReceiptTypes = () => {
    const receiptTypes = {};
    const mySet = new Set();
    Object.keys(maps_js_1.poolInfo).forEach((pool) => {
        const key = pool.replace(/-/g, "_");
        if (!mySet.has(maps_js_1.poolInfo[pool].receiptType)) {
            receiptTypes[key] = {
                type: maps_js_1.poolInfo[pool].receiptType,
                cursor: "",
            };
            mySet.add(maps_js_1.poolInfo[pool].receiptType);
        }
    });
    return receiptTypes;
};
async function fetchMultiReceipts(address) {
    const multiReceipts = [];
    const receiptTypes = getReceiptTypes();
    const batchSize = 10; // Set the desired batch size
    // Convert the receiptTypes object into an array of entries
    const entries = Object.entries(receiptTypes);
    // Create an array to hold the batches
    const batches = [];
    //const batches = [];
    // Loop through the entries array and create batches
    for (let i = 0; i < entries.length; i += batchSize) {
        const batchEntries = entries.slice(i, i + batchSize);
        batches.push(Object.fromEntries(batchEntries)); // Convert to object before pushing
    }
    for (const receiptTypes of batches) {
        let hasNextPage = true;
        try {
            while (hasNextPage) {
                const query = (0, getMultiReceipts_js_1.getMultiReceiptsQuery)(receiptTypes);
                const GET_RECEIPTS = (0, core_1.gql) `
          ${query}
        `;
                const result = await client.query({
                    query: GET_RECEIPTS,
                    variables: {
                        address: address,
                    },
                });
                const data = result.data;
                if (!data)
                    break;
                const receipts = data.address;
                hasNextPage = false;
                Object.keys(receipts).forEach((key) => {
                    if (key !== "__typename") {
                        const entry = receipts[key];
                        if (!entry)
                            return;
                        const { pageInfo, nodes } = entry;
                        hasNextPage = hasNextPage || pageInfo.hasNextPage;
                        if (hasNextPage)
                            receiptTypes[key].cursor = pageInfo.endCursor;
                        else
                            receiptTypes[key].cursor = "0";
                        nodes.forEach((node) => {
                            multiReceipts.push(node);
                        });
                    }
                });
            }
        }
        catch (error) {
            console.warn("Error fetching receipts from GraphQL, now fetching from suiClient query", error);
        }
        finally {
            Object.keys(receiptTypes).forEach((key) => {
                receiptTypes[key].cursor = "";
            });
        }
    }
    const receiptMap = new Map();
    multiReceipts.forEach((receipt) => {
        const name = receipt.contents.json.name;
        let arr = receiptMap.get(name);
        if (!arr)
            arr = [];
        arr.push(receipt);
        receiptMap.set(name, arr);
    });
    return receiptMap;
}
//# sourceMappingURL=getMultiReceipts.js.map